import {authGuard} from '../guards';
import FaxMessages from '../../pages/fax/library/FaxMessages';
import ShowFaxMessage from '../../pages/fax/library/ShowFaxMessage';
import FaxContacts from '../../pages/fax/library/FaxContacts';
import CreateFaxContact from '../../pages/fax/library/CreateFaxContact';
import EditFaxContact from '../../pages/fax/library/EditFaxContact';
import SendFax from '../../pages/fax/library/SendFax';

function getRoutes(routePrefix, layout) {
  const basePath = routePrefix === 'library'
    ? '/v2/app/content/fax'
    : '/v2/mobile/fax';
  return [
    {
      path: `${basePath}`,
      name: `${routePrefix}.fax.home`,
      redirect: `${basePath}/messages`
    },
    {
      path: `${basePath}/send`,
      name: `${routePrefix}.send_fax`,
      component: SendFax,
      meta: {
        layout: layout,
        title: `Send a Fax`,
      },
    },
    {
      path: `${basePath}/contacts`,
      name: `${routePrefix}.fax_contacts.index`,
      component: FaxContacts,
      meta: {
        layout: layout,
        title: `Fax Contacts`,
      },
    },
    {
      path: `${basePath}/contacts/create`,
      name: `${routePrefix}.fax_contact.create`,
      component: CreateFaxContact,
      meta: {
        layout: layout,
        title: `New Fax Contact`,
      },
    },
    {
      path: `${basePath}/contacts/:contactID(\\d+)/edit`,
      name: `${routePrefix}.fax_contact.edit`,
      component: EditFaxContact,
      meta: {
        layout: layout,
        title: `Edit Fax Contact`,
      },
    },
    {
      path: `${basePath}/messages`,
      name: `${routePrefix}.fax_messages.index`,
      component: FaxMessages,
      meta: {
        layout: layout,
        title: `Fax Messages`,
      },
    },
    {
      path: `${basePath}/messages/:messageID(\\d+)`,
      name: `${routePrefix}.fax_message.show`,
      component: ShowFaxMessage,
      meta: {
        layout: layout,
        title: `Fax Message`,
      },
    },
  ];
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
];
